import { useMemo } from "react";
import Cell from "src/generator/Cell/Cell";
import { getColValue } from "src/pages/Reports/Report/Report.utils";
import { useSelector } from "src/redux/hooks";

import { StyledGuernseyTr } from "./Guernsey.styled";

interface Props {
  tag: string | undefined;
  rowIndex: number | undefined;
  summary?: boolean;
  lbeid?: string;
}
const GuernseyChildInput = ({ tag, rowIndex, summary }: Props) => {
  const { guernseyData } = useSelector(state => state.generatorFeaturesSlice);
  const { uppercase } = useSelector(state => state.preferencesSlice);
  const cols = useMemo(() => {
    if (
      !tag ||
      !guernseyData ||
      rowIndex === undefined ||
      !guernseyData[rowIndex]
    )
      return {};

    const index = tag.split("-")[1];
    return guernseyData[rowIndex][index];
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
  }, [guernseyData, tag]);
  return (
    <table>
      {cols &&
        Object.entries(cols).map(([key, col]) => (
          <StyledGuernseyTr key={key}>
            <td
              className="bottom-border"
              style={
                summary && (col.unit === "large/text" || col.unit === "text")
                  ? {
                      maxWidth: "400px",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                    }
                  : undefined
              }>
              {summary ? (
                getColValue({ ...col, hideSig: true }, [], "", null, uppercase)
              ) : (
                <Cell
                  {...(col as any)}
                  uuid={key}
                  unitType={col.unit}
                  value={col.value ?? ""}
                  hideSig
                />
              )}
            </td>
          </StyledGuernseyTr>
        ))}
    </table>
  );
};
export default GuernseyChildInput;
